import axios from '@/utils/axios';
/*

    운임계산관련 API set 입니다.

*/

export function useCharge() {
  /*
    퀵 운임 계산 API 
  */
  const chargeQuick = async (payload: api.charge.quick.payload) => {
    try {
      const { data } = await axios.post<api.charge.quick.response>('/charge/quick', payload);
      if (!data.success) throw data;
      return data;
    } catch (e) {
      throw e;
    }
  };
  /*
    퀵 - 화물 운임 계산 API 
  */
  const chargeQuickFreight = async (payload: api.charge.freightPayload) => {
    try {
      const { data } = await axios.post<api.charge.quick.response>('/charge/freight-quick', payload);
      if (!data.success) throw data;
      return data;
    } catch (e) {
      throw e;
    }
  };

  /**
   * 택배 운임 계산 API
   */
  const chargeParcel = async (payload: api.charge.parcel.payload) => {
    try {
      const { data } = await axios.post<api.charge.parcel.response>('/charge/parcel', payload);
      if (!data.success) throw data;
      return data;
    } catch (e) {
      throw e;
    }
  };

  /**
   * 다량택배접수 운임 API
   */
  const chargeMassParcel = async (payload: api.charge.mass.parcel.payload) => {
    try {
      const { data } = await axios.post<api.charge.mass.parcel.response>('/charge/mass/parcel', payload);
      if (!data.success) throw data;
      return data;
    } catch (e) {
      throw e;
    }
  };

  /**
   * 등기요금 - 균등가(일반/빠른등기) 조회
   * response로 단순 금액만 받으며, 요금 uuid 데이터 쌓이지 않음
   */
  const chargeRegistryUniform = async () => {
    try {
      const { data } = await axios.get<api.charge.registryUniformResponse>('/charge/mail/uniform');
      if (!data.success) throw data;
      return data;
    } catch (e) {
      throw e;
    }
  };

  /**
   * (단건) 등기 요금 조회 API
   * 접수시 요금 uuid 필요로 할때 최종 요금조회 호출
   */
  const chargeRegisteredMail = async (payload: { category: string }) => {
    try {
      const { data } = await axios.post<api.charge.mail.response>('/charge/mail', payload);
      if (!data.success) throw data;
      return data;
    } catch (e) {
      throw e;
    }
  };

  /**
   * 다량등기 요금 조회 API
   * 각각의 요금 uuid를 가져야만 접수 가능
   */
  const chargeMassRegistry = async (payload: api.charge.massRegistryPayload) => {
    try {
      const { data } = await axios.post<api.charge.massRegistryResponse>('/charge/mass/mail', payload);
      if (!data.success) throw data;
      return data;
    } catch (e) {
      throw e;
    }
  };

  return {
    chargeQuick,
    chargeQuickFreight,
    chargeParcel,
    chargeMassParcel,
    chargeMassRegistry,
    chargeRegisteredMail,
    chargeRegistryUniform,
  };
}
